<template lang="html">
    <div class="container">
      <div class="row">
        <div class="content main__content col-md-12">
          <div class="registration-page guest-forms" id="registration-page"><br/>
            <div>
              <div class="panel panel-default panel-login">
                <div class="panel-heading">
                  <ul>
                    <li><a href="/login">{{ $t('Авторизация') }}</a></li>
                    <li class="active"><a href="/reg">{{ $t('Регистрация') }}</a></li>
                  </ul>
                </div>
                <div class="panel-body">
                  <form>
                    <div class="split-two">
                      <guest-form-group :label-text="$t('E-mail')" :required="true" :has-error="model.errors.has('email')" :error-message="model.errors.getMessage('email')">
                        <input class="form-control" type="email" :disabled="isModelDisabled" autocomplete="off" v-model="model.values.email" :placeholder="$t('E-mail')"/>
                      </guest-form-group>
                      <guest-form-group :label-text="$t('Промокод')" :required="false" :has-error="model.errors.has('refCode')" :error-message="model.errors.getMessage('refCode')">
                        <input class="form-control" type="text" :disabled="isPromocodeDisabled" autocomplete="off" v-model="model.values.refCode" :placeholder="$t('Промокод')"/>
                      </guest-form-group>
                    </div>
                    <div class="split-two">
                      <guest-form-group :label-text="$t('Пароль')" :required="true" :has-error="model.errors.has('password')" :error-message="model.errors.getMessage('password') ? $t(model.errors.getMessage('password')) : ''">
                        <input class="form-control" type="password" :disabled="isModelDisabled" autocomplete="new-password" v-model="model.values.password" :placeholder="$t('Пароль')"/>
                      </guest-form-group>
                      <guest-form-group :label-text="$t('Повтор пароля')" :required="true" :has-error="model.errors.has('password2')" :error-message="model.errors.getMessage('password2')? $t(model.errors.getMessage('password2')) : ''">
                        <input class="form-control" type="password" :disabled="isModelDisabled" autocomplete="new-password" v-model="model.values.password2" :placeholder="$t('Пароль')"/>
                      </guest-form-group>
                    </div>



                    <hr/>
                    <div class="split-captcha form-group-margin-bottom">
                      <guest-form-group :label-text="$t('Код с картинки')" :required="true" :has-error="model.errors.has('captchaCode')" :error-message="model.errors.getMessage('captchaCode')">
                        <input class="form-control" type="text" :disabled="isModelDisabled" v-model="model.values.captchaCode" :placeholder="$t('Код с картинки')"/>
                      </guest-form-group>
                      <div>
                        <registration-captcha captcha-url="/webapi/auth/regcaptchasupershort" ref="regCaptcha"></registration-captcha>
                      </div>
                    </div>
                    <!--.form-group-->
                    <guest-form-group :has-error="model.errors.has('newsletter')" :error-message="model.errors.getMessage('newsletter')">
                      <label>
                        <input class="reg-newsletter-checkbox" type="checkbox" :disabled="isModelDisabled" v-model="model.values.newsletter"/><span class="checkbox-label">
                        <div>{{$t('Я не против получать свежие новости на e-mail.')}}</div></span>
                      </label>
                      <!--model-error-help-block(:model="model" attribute="newsletter")-->
                    </guest-form-group>
                    <!--.form-group-->
                    <guest-form-group :has-error="model.errors.has('acceptedAgreement')" :error-message="model.errors.getMessage('acceptedAgreement')">
                      <label>
                        <input class="reg-agreement-checkbox" type="checkbox" :disabled="isModelDisabled" v-model="model.values.acceptedAgreement"/><span class="checkbox-label">
                        <i18n path="agreementlabel" tag="div">
                          <template v-slot:link><a target="_blank" href="/useragreement">{{$t('agreementlinklabel')}}</a></template>
                        </i18n></span>
                      </label>
                    </guest-form-group>
                    <div class="text-center">
                      <button class="btn btn-success" type="button" @click.prevent="submit" :disabled="isRegisterDisabled">{{$t('Зарегистрироваться')}}</button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
</template>

<script lang="ts" setup>
import { ref, computed,
  onMounted, reactive, getCurrentInstance } from "vue";
import {RegistrationSuperShortModel} from "@/views/pages/auth/registration";
import GuestFormGroup from "@/components/forms/guest/GuestFormGroup.vue";
import RegistrationCaptcha from "@/views/pages/auth/reg/RegistrationCaptcha.vue";
import  "primevue/resources/primevue.min.css";
import {useRoute, useRouter} from "vue-router/composables";
import Cookies from 'js-cookie';
import router from "@/router";

const route = useRoute();

const props = defineProps({
  from: {
    type: String,
    required: false,
    default: null
  },
})

const registrationQueryValues = computed(() => {
  return {
    refCode: route.query.from || route.params.from || Cookies.get('ReferralCode') || '',
    inviteCode: route.query.invite || '',
    referrer: Cookies.get('TheReferer') || '',
    category: route.query.a || '',
  }
})

const model = reactive(new RegistrationSuperShortModel());
const redirecting = ref(false);

const isModelDisabled = computed(() => {
  return model.submitstate.isLoading || redirecting.value;
})

const isPromocodeDisabled = computed(() => {
  return isModelDisabled.value || registrationQueryValues.value.refCode?.length > 0;
})

const locale = computed(() => {
  return getCurrentInstance()?.proxy?.$i18n.locale || 'ru';
})

const isRegisterDisabled = computed(() => {
  return isModelDisabled.value
    || !model.values.acceptedAgreement;
})



declare function ym(a, b, c): void;
// declare function $t(a): string;

const yandexMetrikaRegisterFinal = (usertype) => {

  try {

    if (typeof ym === 'function') {
      if (usertype === 'INDIVIDUAL') {
        ym(55378108,'reachGoal','REG_PERSONAL')
      }
      if (usertype === 'LEGAL') {
        ym(55378108,'reachGoal','REG_BUSINESS')
      }
    }
  } catch (e) {

  }
}

const regCaptcha = ref(null);

const submit = () => {
  model.errors.clear();

  model.values = {...model.values, ...registrationQueryValues.value};

  model.submit().then(() => {
    redirecting.value = true;
    // yandexMetrikaRegisterFinal(model.values.userType);

    setTimeout(() => {
      window.location.href = '/regconfirm';
    }, 1000);
  }).catch((e) => {
    regCaptcha.value?.forceUpdate();
    model.values.captchaCode = '';
  })
}

onMounted(() => {
  // if (!registrationQueryValues.value.category
  //     || !registrationQueryValues.value.category.length
  //     i!registrationQueryValues.value.refCode
  //     || !registrationQueryValues.value.refCode.length) {
  //
  //   const qs = new URLSearchParams(window.location.search);
  //   const url = '/reg?' + qs.toString();
  //   router.push(url).then(() => {
  //     window.location.reload();
  //   })
  // }

  model.values = {...model.values, ...registrationQueryValues.value};
})
</script>




<style scoped lang="less">
@import "flex-mixins";

.display--contents {
  display: contents;
}

.border-radius(@radius: 5px) {
  -webkit-border-radius: @radius;
  -moz-border-radius: @radius;
  border-radius: @radius;
}

.reg-contacts-required-alert {
  margin-top: 5px;

  .border-radius(4px);
  // border: 1px solid #f6cc09;
  border: 1px solid #f2e483;
  padding: 15px;
  .glyphicon {
    color: #f6cc09;
    font-size: 120%;
  }

  .flex-display(flex);
  .flex-direction(row);
  .flex-wrap(nowrap);

  > div:first-child {
    width: 20px;
    margin-right: 15px;
  }
  .text-muted {
    text-align: justify;
  }
}

.split-two {
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 20px;
}
.split-captcha {
  display: grid;
  grid-template-columns: 1fr max-content;
  grid-gap: 20px;
  ::v-deep {
    .captcha-image {
      margin-top: 26px;
    }
  }
}

.form-group-margin-bottom {
  margin-bottom: 25px;
}
.split-two-contacts {
  display: grid;
  grid-template-columns: auto max-content;
  grid-gap: 20px;
  align-items: center;
  h3 {
    margin: 0;
  }
}
.p-dropdown {
  width: 100%;
  height: 4.8rem;

  box-shadow: inset 0 2px 3px 0 rgba(0, 0, 0, 0.1);
  background-color: #f2f3f8;
  border: none;
  ::v-deep {
    .p-dropdown-trigger {
      width: 3.357rem;
      .pi {
        font-size: 1.2rem;
      }
    }
    .p-dropdown-panel {
      box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.2);
      font-size: 1.4rem;


      .p-dropdown-item {
        .p-dropdown-group-option {
          padding-top: 1rem;
          color: #000;
          font-size: 0.8em;
          border-bottom: 1px solid #ebebeb;
          text-align: center;
        }
        .p-dropdown-group-option {

        }
        &.p-highlight {
          background: #80bd1c;
          color: #fff;
        }
      }
    }
    input {
      //height: 4.8rem;
      //padding: 6px 0 0 12px;
    }
    .p-inputtext {
      font-size: 1.4rem;

      padding: 5px 12px;
      display: flex;
      align-items: center;
    }
    .p-hidden-accessible {
      display: none;
      input[text] {
        display: none;
      }
    }
  }

}
</style>

<i18n>
{
  "en": {
    "Арбитражник (соло)": "Arbitrage master",
    "Арбитражная команда": "Arbitrage team",
    "Вебмастер": "Webmaster",
    "Криптоинвестор": "Cryptoinvestor",
    "Рекламодатель (СНГ)": "Advertiser (CIS)",
    "Рекламодатель (МИР)": "Advertiser (World)",
    "Партнерская программа": "Affiliate program",
    "Рекламная сеть": "Advertising network",
    "Криптобиржа": "Cryptoexchange",
    "Криптообменник": "Crypto exchanger",
    "Образование": "Education",
    "Маркетинговое агентство": "Marketing agency",
    "Беттинг": "Betting",
    "Казино": "Casino",
    "Форекс": "Forex",
    "Логин или email": "Username or e-mail",
    "Пароль": "Password",
    "Авторизация": "Authorization",
    "Регистрация": "Registration",
    "Выберите область деятельности...": "Select your field of activity...",
    "Сфера деятельности": "Field of activity",
    "Я не против получать свежие новости на e-mail.": "I wish to receive newsletter emails and special offer notices from Capitalist.",
    "Код с картинки": "Captcha code",
    "Контактная информация": "Contacts",
    "Имя в Skype": "Skype account",
    "Номер телефона": "Phone number",
    "Никнейм": "Nickname",
    "Повтор пароля": "Repeat the password",
    "Частное лицо": "Individual",
    "Бизнес": "Business",
    "Логин": "Username",
    "agreementlabel": "I have read and agreed with the terms and conditions of the {link}",
    "agreementlinklabel": "User's agreement",
    "Зарегистрироваться": "Register",
    "Тип пользователя": "User type",
    "contactsrequirednotice": "Please fill one of the contacts at least for your personal manager.",
    "Адрес сайта": "Website",
    "Выберите из списка...": "Select from list...",
    "Необходимо заполнить пароль.": "Required field.",
    "Пароли не совпадают.": "The passwords are not equal.",
    "Длина пароля должна быть от 6 до 40 символов.": "Password length should be from 6 to 40 characters.",
    "Другая сфера деятельности": "Other field of activity",
    "Пожалуйста, введите сферу деятельности": "Please enter your field of activity",
    "Сервисы": "Services",
    "Другое": "Other",
    "category_name": {
      "business": "Business",
      "individual": "Individual",
      "business_service": "Services",
      "business_advertising_network": "Advertising networks",
      "business_affiliate_network": "Affiliate programs",
      "business_webmaster_service": "Webmaster services",
      "business_marketing_agency": "Marketing agencies"
    },
    "Промокод": "Promocode"
  },
  "ru": {
    "category_name": {
      "business": "Бизнес",
      "individual": "Частное лицо",
      "business_service": "Сервисы",
      "business_advertising_network": "Рекламные сети",
      "business_affiliate_network": "Партнерские программы",
      "business_webmaster_service": "Сервисы для вебмастеров",
      "business_marketing_agency": "Маркетинговые агентства"
    },
    "agreementlabel": "Я ознакомлен и согласен с условиями {link}",
    "agreementlinklabel": "Пользовательского соглашения",
    "contactsrequirednotice": "Пожалуйста, оставьте свои контактные данные для связи с Вашим персональным менеджером. Обязательным является заполнение как минимум одного поля."
  }
}
</i18n>

